export function isBudgetTableShared(campaign) {
  return campaign?.budget_table_visible === true
}

export function isProjectTimelineShared(scenario) {
  return scenario?.timeline_visible === true
}

export function advertiserShareFallbackPath({ scenario, campaign }) {
  if (isProjectTimelineShared(scenario)) return 'project_timeline'
  if (isBudgetTableShared(campaign)) return 'budget_table'
  if (campaign?.show_report) return 'campaign_report'
  return 'influencers'
}
